import { render, staticRenderFns } from "./solutionsTab3.vue?vue&type=template&id=80e5af58&"
import script from "./solutionsTab3.vue?vue&type=script&lang=js&"
export * from "./solutionsTab3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports